import React from 'react'

import { NavLink } from 'react-router-dom'

import { List, ListItem, ListItemText, useTheme } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const TrainingNav = (props) => {
	const { selectedFacility, location } = props
	const classes = useStyles()

	return (
		<List className={classes.defaultNav}>
			<ListItem
				component={NavLink}
				exact
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/training/schedule`}>
				<ListItemText primary="Training Schedule" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/training/calendar`}>
				<ListItemText primary="Training Calendar" />
			</ListItem>
		</List>
	)
}

export default TrainingNav
